const pms_suburban_or_rural = [
  {
    value: "suburban",
    name: "Suburban",
  },
  {
    value: "rural",
    name: "Rural",
  },
];

export default pms_suburban_or_rural;



// WEBPACK FOOTER //
// ./src/constants/pms_suburban_or_rural.js